'use strict';

/** @type {import('./uri')} */
module.exports = URIError;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es-errors@1.3.0/~/es-errors/uri.js
// module id = 724
// module chunks = 0